__turbopack_context__.v({
  "action": "NotificationsPanel-module-scss-module__f2s_Aa__action",
  "body": "NotificationsPanel-module-scss-module__f2s_Aa__body",
  "clearAll": "NotificationsPanel-module-scss-module__f2s_Aa__clearAll",
  "dismiss": "NotificationsPanel-module-scss-module__f2s_Aa__dismiss",
  "dismissible": "NotificationsPanel-module-scss-module__f2s_Aa__dismissible",
  "header": "NotificationsPanel-module-scss-module__f2s_Aa__header",
  "heading": "NotificationsPanel-module-scss-module__f2s_Aa__heading",
  "icon": "NotificationsPanel-module-scss-module__f2s_Aa__icon",
  "item": "NotificationsPanel-module-scss-module__f2s_Aa__item",
  "more": "NotificationsPanel-module-scss-module__f2s_Aa__more",
  "panel": "NotificationsPanel-module-scss-module__f2s_Aa__panel",
  "row": "NotificationsPanel-module-scss-module__f2s_Aa__row",
  "rows": "NotificationsPanel-module-scss-module__f2s_Aa__rows",
  "scroll": "NotificationsPanel-module-scss-module__f2s_Aa__scroll",
  "shimmer": "NotificationsPanel-module-scss-module__f2s_Aa__shimmer",
  "skeletonRow": "NotificationsPanel-module-scss-module__f2s_Aa__skeletonRow",
  "srOnly": "NotificationsPanel-module-scss-module__f2s_Aa__srOnly",
  "state": "NotificationsPanel-module-scss-module__f2s_Aa__state",
  "stateIcon": "NotificationsPanel-module-scss-module__f2s_Aa__stateIcon",
  "stateText": "NotificationsPanel-module-scss-module__f2s_Aa__stateText",
  "text": "NotificationsPanel-module-scss-module__f2s_Aa__text",
  "time": "NotificationsPanel-module-scss-module__f2s_Aa__time",
  "title": "NotificationsPanel-module-scss-module__f2s_Aa__title",
  "titleRow": "NotificationsPanel-module-scss-module__f2s_Aa__titleRow",
});
